module.exports = __webpack_public_path__ + "img/women.397daeb5.jpg";